<aside
  class="w-full h-full bg-primary-950 overflow-y-auto shadow-xl"
>
  <!-- HEADER -->
  <div class="p-4 border-b border-primary-800">
    <button
      onclick="history.back()"
      class="w-full h-12 flex items-center justify-start text-2xl bg-transparent hover:bg-white/10 text-white/70 hover:text-white border-0 rounded-lg transition-all duration-200 group"
    >
      <i
        class="ri-arrow-left-long-line mr-3 group-hover:translate-x-[-2px] transition-transform duration-200"
      ></i>
      <span class="text-sm font-medium">Back</span>
    </button>
  </div>

  <!-- MENU -->
  <nav class="px-3 py-4">
    <ul class="space-y-1">
      @for (menu of menus; track menu.id) {
      <li>
        <!-- ================= PARENT ================= -->
        @if (hasSubMenus(menu)) {
        <div class="cursor-pointer" (click)="toggleMenu(menu)">
          <div
            class="flex items-center justify-between px-4 py-3 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-all"
          >
            <span class="text-sm font-medium">
              {{ menu.menu_name }}
            </span>

            <i
              class="ri-arrow-down-s-line transition-transform duration-200"
              [class.rotate-180]="menu.expanded"
            ></i>
          </div>

          @if (menu.expanded) {
          <ul class="ml-4 mt-2 space-y-1">
            <ng-container
              *ngTemplateOutlet="
                recursiveMenu;
                context: { $implicit: menu.sub_menus }
              "
            ></ng-container>
          </ul>
          }
        </div>
        }
        <!-- ================= LEAF ================= -->
        @else {
        <a
          [routerLink]="menu.url || null"
          routerLinkActive="router-link-active"
          class="flex items-center px-4 py-3 text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-all"
        >
          <span class="text-sm font-medium">
            {{ menu.menu_name }}
          </span>
        </a>
        }
      </li>
      }
    </ul>
  </nav>

  <!-- ================= RECURSIVE TEMPLATE ================= -->
  <ng-template #recursiveMenu let-items>
    @for (item of items; track item.id) {
    <li>
      @if (hasSubMenus(item)) {
      <div (click)="toggleMenu(item)" class="cursor-pointer">
        <div
          class="flex items-center justify-between px-4 py-2 text-white/70 hover:text-white hover:bg-white/5 rounded-lg transition-all"
        >
          <span class="text-xs font-medium">
            {{ item.menu_name }}
          </span>

          <i
            class="ri-arrow-down-s-line text-sm transition-transform duration-200"
            [class.rotate-180]="item.expanded"
          ></i>
        </div>

        @if (item.expanded) {
        <ul class="ml-4 mt-1 space-y-1">
          <ng-container
            *ngTemplateOutlet="
              recursiveMenu;
              context: { $implicit: item.sub_menus }
            "
          ></ng-container>
        </ul>
        }
      </div>
      } @else {
      <a
        [routerLink]="item.url || null"
        routerLinkActive="router-link-active"
        class="flex items-center px-4 py-2 text-white/60 hover:text-white hover:bg-white/5 rounded-lg transition-all"
      >
        <span class="text-xs font-medium">
          {{ item.menu_name }}
        </span>
      </a>
      }
    </li>
    }
  </ng-template>
</aside>
